/**
 * Created by mac on 12/28/20
 */
let Mines;
// eslint-disable-next-line prefer-const
Mines = {
    fruit: FruitMine.prize,
    drfruit: FeedFruitMine.prize,
    source: SourceMine.prize,
    merge3generator: GeneratorSourceMine.prize,
    monster: MonsterMine.prize,
    coinstree: ValuableMine.prize,
    energytree: ValuableMine.prize,
    magicplant: MagicplantMine.prize
};
